import * as yup from "yup";
import { nameValidator } from "./commonValidators";

export const addGroupValidator = yup.object({
  name: nameValidator,
});
